import { Box, styled } from '@mui/joy';

export const EmptyStateWrapper = styled(Box)(({ theme }) => ({
  height: '100%',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.vars.palette.background.surface,
  borderRadius: 8,
  marginBottom: 16,
  padding: 16,
}));
